export const LOGIN_SUCCESS = 'LOGIN_SUCESS';
export const LOGOUT = 'LOGOUT';
export const STORE_USER_DETAIL = "STORE_USER_DETAIL";

